<template>
    <form @submit.prevent="sign" class="external-sign mt-4">
        <div v-if="isLocalhost" class="my-5">
            <h6>DEBUG</h6>
            <p>Item ID: {{itemId}}</p>
        </div>

        <p v-if="itemDescription" class="my-3">
          <small class="text-muted font-italic" v-html="itemDescriptionWithBr"></small>
        </p>

        <label :for="`${uuid}-name`">{{$t('sign.external.name_label')}}</label>
        <input :id="`${uuid}-name`" type="text" class="form-control mb-4" required v-model="name" placeholder="John Doe">

        <div v-if="!authenticating">
            <button type="submit" class="signatureComponentSignButton btn btn-secondary mb-3" :disabled="!hasData">
                <i class="fas fa-paper-plane mr-1"></i>
            </button>
        </div>
        <button v-else type="button" class="signatureComponentSignButton btn btn-primary mt-3 wait">
            <div class="spinner-border spinner-border-sm mr-2"></div> <i class="fas fa-paper-plane"></i>
        </button>
    </form>
</template>

<style lang="scss" scoped>
button {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 33%;

    &.wait .spinner-border {
        vertical-align: middle;
    }
}
</style>

<script setup>
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { computed, ref, watch } from "vue";

// Props should be in sync with bankIdSign.vue
const props = defineProps({
    itemId: { type: String, default: undefined },
    itemDescription: { type: String, default: undefined },
    appUrl: { type: String, default: undefined },
    redirectOnSignedUrl: { type: String, default: undefined },
    signeeName: { type: String, default: null },
});
const emit = defineEmits(["signed"]);

const uuid = uuidv4();
const name = ref(props.signeeName);
const authenticating = ref(false);
const hasData = ref(!!props.signeeName);

const isLocalhost = computed(() => document.location.hostname === "localhost");
const itemDescriptionWithBr = computed(() =>
    props.itemDescription ? props.itemDescription.replaceAll("\n", "<br>") : null
);

watch(name, updateHasData);

async function sign() {
    try {
        authenticating.value = true;
        await axios.post("/external_signatures", {
            item_id: props.itemId,
            item_description: props.itemDescription,
            name: name.value,
        });

        if (props.redirectOnSignedUrl) {
            window.location.replace(props.redirectOnSignedUrl);
        } else {
            emit("signed");
        }
    } catch (error) {
        authenticating.value = false;
        console.warn("Failed to store signature..", error);
    }
}

function updateHasData() {
    hasData.value = !!name.value;
}
</script>
